import { Avatar, Button, Divider, Stack, Typography } from '@mui/material';
import { ButtonsBackground } from 'Components/ButtonsBackground';
import { Download2, LeftArrow } from 'Images';
import { isDesktop } from 'react-device-detect';

interface IButton {
  label: string;
  ariaLabel?: string;
  icon?: string;
  onClick: () => void;
  labelColor?: string;
}

interface IOneOrTwoButtons {
  rightButton?: IButton;
  leftButton?: IButton;
  width?: string;
  buttonsBackground?: boolean;
  buttonsBackgroundColor?: string;
  cardVariant?: boolean;
  isMobileVersion?: boolean;
  rightButtonRole?: string;
  leftButtonRole?: string;
}

export const OneOrTwoButtons = ({
  rightButton,
  leftButton,
  width,
  buttonsBackground = false,
  buttonsBackgroundColor,
  cardVariant,
  isMobileVersion,
  rightButtonRole,
  leftButtonRole,
}: IOneOrTwoButtons) => {
  if (!rightButton && !leftButton) return null;

  return isMobileVersion ? (
    <Stack
      flexDirection={'row'}
      gap={isDesktop ? '8px' : '6px'}
      height={isDesktop ? '56px' : '42px'}
      justifyContent={rightButton ? 'space-around' : 'end'}
      alignItems={'center'}
      p={isDesktop ? '18px 32px' : '18px 20px'}
      position={'relative'}
      overflow={'hidden'}
      mt={isDesktop ? '32px' : '24px'}
    >
      <ButtonsBackground />
      {rightButton && (
        <>
          <Button
            onClick={rightButton.onClick}
            onKeyUp={(e: React.KeyboardEvent) => {
              e.key === 'Enter' && rightButton.onClick();
            }}
            aria-label={rightButton.ariaLabel}
          >
            <Avatar
              src={rightButton.icon || Download2}
              alt=''
              sx={{ width: '20px', height: '20px', mr: 1 }}
            />
            <Typography
              variant='body5'
              color={rightButton.labelColor && rightButton.labelColor}
            >
              {rightButton.label}
            </Typography>
          </Button>

          {leftButton && (
            <Divider
              aria-hidden='true'
              orientation='vertical'
              flexItem
              variant='middle'
              sx={{
                borderColor: 'primary.shade_200',
                mr: width ? '20px' : undefined,
                ml: width ? '11px' : undefined,
              }}
            />
          )}
        </>
      )}
      {leftButton && (
        <Button
          onClick={leftButton?.onClick}
          onKeyUp={(e: React.KeyboardEvent) => {
            e.key === 'Enter' && leftButton?.onClick();
          }}
          sx={{ display: 'flex', p: '6px 0' }}
          aria-label={leftButton?.ariaLabel}
        >
          <Typography
            variant='body5'
            color={leftButton?.labelColor && leftButton?.labelColor}
          >
            {leftButton?.label}
          </Typography>
          <Avatar
            src={leftButton?.icon || LeftArrow}
            alt=''
            sx={{ width: '20px', height: '20px' }}
          />
        </Button>
      )}
    </Stack>
  ) : (
    <Stack
      flexDirection={'row'}
      sx={{
        cursor: 'pointer',
        backgroundColor: 'primary.shade_100',
        boxShadow: cardVariant
          ? undefined
          : '0px 2px 8px 0px rgba(4, 16, 46, 0.04)',
        border: cardVariant ? undefined : '1px solid rgba(183, 204, 255, 0.20)',
        borderRadius: cardVariant ? '0 0 16px 16px' : '100px',
        p: isDesktop ? '5px 16px' : '4px 15px',
        whiteSpace: 'nowrap',
        width: width || 'fit-content',
        justifyContent: rightButton
          ? 'space-between'
          : cardVariant
          ? 'end'
          : 'center',
        alignItems: 'center',
        marginLeft: 'auto',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {buttonsBackground && (
        <ButtonsBackground buttonsBackgroundColor={buttonsBackgroundColor} />
      )}
      {rightButton && (
        <>
          <Button
            variant='textBtn'
            onClick={rightButton.onClick}
            onKeyUp={(e: React.KeyboardEvent) => {
              e.key === 'Enter' && rightButton.onClick();
            }}
            aria-label={rightButton.ariaLabel}
            role={rightButtonRole || 'button'}
            sx={{
              textDecoration: 'none',
              ':hover': {
                textDecoration: 'underline',
              },
            }}
          >
            <Avatar
              src={rightButton.icon || Download2}
              alt=''
              sx={{ width: '20px', height: '20px', mr: 1 }}
            />
            <Typography
              variant='body5'
              color={rightButton.labelColor && rightButton.labelColor}
            >
              {rightButton.label}
            </Typography>
          </Button>

          {leftButton && (
            <Divider
              aria-hidden='true'
              orientation='vertical'
              flexItem
              variant='middle'
              sx={{
                borderColor: 'primary.shade_200',
                mr: width ? '20px' : undefined,
                ml: width ? '11px' : undefined,
              }}
            />
          )}
        </>
      )}
      {leftButton && (
        <Button
          variant='textBtn'
          onClick={leftButton?.onClick}
          onKeyUp={(e: React.KeyboardEvent) => {
            e.key === 'Enter' && leftButton?.onClick();
          }}
          sx={{
            display: 'flex',
            p: '6px 0',
            textDecoration: 'none',
            ':hover': {
              textDecoration: 'underline',
            },
          }}
          aria-label={leftButton?.ariaLabel}
          role={leftButtonRole || 'button'}
        >
          <Typography
            variant='body5'
            color={leftButton?.labelColor && leftButton?.labelColor}
          >
            {leftButton?.label}
          </Typography>
          <Avatar
            src={leftButton?.icon || LeftArrow}
            alt=''
            sx={{ width: '20px', height: '20px' }}
          />
        </Button>
      )}
    </Stack>
  );
};
